const SNIPPET1 = [
  {
    title: 'Al\'s extreme Donkey Kong resto',
    data: 'PAC-MANs super detailed restoration, making DK factory fresh again!',
    readit: '',
    url: 'http://www.ukvac.com/forum/donkey-kong_topic333124.html',
    imgurl: 'http://i9.photobucket.com/albums/a74/PACMAN1980/85a5f408-4958-4e73-89d5-f316b654ee4a_zps35b89db0.jpg',
    objectID: 0
  }
];

export default SNIPPET1;


// WEBPACK FOOTER //
// ./src/data-forumsnippet1.js